import './HeaderText.css';

/** From Figma — «УЛЕТНЫЙ БИЛЕТ», top 145.5 / left 284. */
export function HeaderText() {
  return (
    <div className="tickets-header-text" role="img" aria-label="Улётный билет">
      УЛЕТНЫЙ БИЛЕТ
    </div>
  );
}
